import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import { Button } from '@cropler/ui-kit';
import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import { useLocalStorage } from '../../hooks';
import { Workspace } from '../../constants/keys';
import { Organization } from '../WorkspaceModal/Organization.jsx';
import RequestButton from '../GlobalComponents/RequestButton.jsx';

const EmptyView = ({ t, message = '', title = '', showRequestButton }) => {
  const navigate = useNavigate();
  const { currentUserRole, currentUserWorkspaces } = useSelector((state) => state.auth);
  const [workspaceId] = useLocalStorage(Workspace, '');
  const [activeAddWorkspace, setActiveAddWorkspace] = useState(false);

  const onOpenAddPanel = () => {
    setActiveAddWorkspace(!activeAddWorkspace);
  };

  return (
    <div className={`${styles.emptyView} container`}>
      <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160" fill="none">
        <path
          fill="var(--neutral-3)"
          d="M75.765 2.161c2.088-2.881 6.382-2.881 8.47 0l5.982 8.254a5.23 5.23 0 0 0 6.973 1.388l8.685-5.337c3.032-1.864 6.999-.22 7.825 3.241l2.368 9.915a5.23 5.23 0 0 0 5.912 3.95l10.066-1.607c3.514-.561 6.55 2.475 5.989 5.99l-1.607 10.066a5.23 5.23 0 0 0 3.95 5.911l9.915 2.368c3.461.826 5.104 4.793 3.241 7.825l-5.336 8.685a5.23 5.23 0 0 0 1.387 6.973l8.254 5.982c2.881 2.088 2.881 6.382 0 8.47l-8.254 5.982a5.23 5.23 0 0 0-1.387 6.973l5.336 8.685c1.863 3.032.22 6.999-3.241 7.825l-9.915 2.368a5.23 5.23 0 0 0-3.95 5.912l1.607 10.066c.561 3.514-2.475 6.55-5.989 5.989l-10.066-1.607a5.23 5.23 0 0 0-5.912 3.95l-2.368 9.915c-.826 3.461-4.793 5.105-7.825 3.241l-8.685-5.336a5.23 5.23 0 0 0-6.973 1.387l-5.982 8.254c-2.088 2.881-6.382 2.881-8.47 0l-5.982-8.254a5.23 5.23 0 0 0-6.973-1.387l-8.685 5.336c-3.032 1.864-6.999.22-7.825-3.241l-2.368-9.915a5.23 5.23 0 0 0-5.912-3.95l-10.066 1.607c-3.514.561-6.55-2.475-5.989-5.989l1.607-10.066a5.23 5.23 0 0 0-3.95-5.912L9.707 113.7c-3.461-.826-5.105-4.793-3.241-7.825l5.337-8.685a5.23 5.23 0 0 0-1.388-6.973l-8.254-5.982c-2.881-2.088-2.881-6.382 0-8.47l8.254-5.982a5.23 5.23 0 0 0 1.388-6.973l-5.337-8.685c-1.864-3.032-.22-6.999 3.241-7.825l9.915-2.368a5.23 5.23 0 0 0 3.95-5.912l-1.607-10.066c-.561-3.514 2.475-6.55 5.99-5.989l10.066 1.607a5.23 5.23 0 0 0 5.911-3.95L46.3 9.707c.826-3.461 4.793-5.105 7.825-3.241l8.685 5.337a5.23 5.23 0 0 0 6.973-1.388l5.982-8.254Z"
        />
        <path
          fill="var(--neutral-1)"
          d="M108.3 65.066a.631.631 0 0 1 0-.267.573.573 0 0 1 0-.233v-.3l-.2-.5a1.586 1.586 0 0 0-.3-.366l-.3-.267h-.167l-13.133-8.3-12.4-7.667a2.832 2.832 0 0 0-.967-.5h-.266a2.736 2.736 0 0 0-.9 0h-.334a3.767 3.767 0 0 0-1.1.434l-24.9 15.5-.3.233-.3.267-.333.233-.167.2-.2.5v.5a2.298 2.298 0 0 0 0 .666v29.1a3.333 3.333 0 0 0 1.567 2.834l25 15.467.5.2h.267a2.88 2.88 0 0 0 1.733 0h.267l.5-.2 24.8-15.234a3.334 3.334 0 0 0 1.566-2.833v-29.1s.067-.234.067-.367ZM80 53.9l5.933 3.666L67.3 69.1l-5.967-3.667L80 53.899Zm-3.333 50L58.333 92.7V71.4l18.334 11.333V103.9ZM80 76.866l-6.367-3.833 18.634-11.567 6.4 3.967L80 76.866ZM101.667 92.6 83.333 104V82.733l18.334-11.334v21.2Z"
        />
      </svg>

      {title && <h1 className={`${styles.emptyViewTitle} h1`}>{title}</h1>}

      {!currentUserWorkspaces.length && workspaceId ? (
        t('empty.workspaces')
      ) : (
        <p>{message ? message : t('empty.sensors')}</p>
      )}

      {!showRequestButton && (currentUserRole === 'owner' || currentUserRole === 'editor') && (
        <div className={styles.emptyViewNav}>
          <Button type="primary" onClick={() => navigate('/devices')}>
            {t('empty.buttonStorage')}
          </Button>
        </div>
      )}

      {!showRequestButton && !currentUserWorkspaces.length && workspaceId && (
        <>
          <Button type="primary" icon={<CroplerIcon name="add" />} onClick={() => onOpenAddPanel()}>
            {t('workspaces.buttonAdd')}
          </Button>
          <Modal
            open={activeAddWorkspace}
            onCancel={() => setActiveAddWorkspace(false)}
            footer={false}
            centered
            width={450}
          >
            <Organization setActiveModal={() => setActiveAddWorkspace(false)} showOnlyCreateForm={true} t={t} />
          </Modal>
        </>
      )}

      {showRequestButton && <RequestButton text={t('empty.buttonSensorRequest')} t={t} />}
    </div>
  );
};

export default EmptyView;
